module.exports = __webpack_public_path__ + "static/media/avatar.78d4db3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/avatar.jpg
// module id = 472
// module chunks = 0